import { IFsFileType } from "@r3f-component-data-structure";
import { FsImage } from "./image";
export class FsImageTarget extends FsImage {
    type = IFsFileType.ImageTarget;
    _filename = 'img';
    _zpt;
    async getZpt() {
        if (typeof this._zpt !== 'undefined')
            return this._zpt;
        const url = new URL(this.baseUrl);
        url.pathname = `${url.pathname}/zpt`;
        const blob = await this.fs.getFileBlob(url.toString());
        const zptBinary = await blob.arrayBuffer();
        this._zpt = new Uint8Array(zptBinary);
        const header = (new TextDecoder()).decode(this._zpt.slice(0, 32));
        if (!header.startsWith('ZPT+IMG')) {
            console.warn(`ZPT file ${this.id} does not contain an image, fetching from URLs...`);
            // This is an older ZPT file, so it doesn't contain an image and we need to fetch it from 3 possible URLs
            const urlsToTry = [
                `https://d1sonmy4sf0d9y.cloudfront.net/trackingimage/${this.id}/img`,
                `https://d1sonmy4sf0d9y.cloudfront.net/tracking-image/${this.id}/img`,
                `https://d1sonmy4sf0d9y.cloudfront.net/zpt/${this.id}/img`
            ];
            let image;
            for (const tryUrl of urlsToTry) {
                try {
                    const headReq = await fetch(tryUrl, { method: 'HEAD' });
                    if (headReq.ok) {
                        const getReq = await fetch(tryUrl);
                        image = new Uint8Array(await getReq.arrayBuffer());
                        break;
                    }
                }
                catch (e) { /**/ }
            }
            if (typeof image !== 'undefined') {
                const zptFileHeader = new Uint8Array(32);
                const imageType = this.getImageMimeType(image);
                zptFileHeader.set(new TextEncoder().encode(`ZPT+IMG${zptBinary.byteLength};${imageType}`));
                const concatZpt = new Uint8Array(zptFileHeader.byteLength + zptBinary.byteLength + image.byteLength);
                concatZpt.set(zptFileHeader, 0);
                const zptByteArray = new Uint8Array(zptBinary);
                concatZpt.set(zptByteArray, zptFileHeader.byteLength);
                concatZpt.set(image, zptFileHeader.byteLength + zptByteArray.byteLength);
                this._zpt = concatZpt;
            }
        }
        return this._zpt;
    }
    getImageMimeType(image) {
        const header = image.slice(0, 4);
        if (header[0] === 0x89 && header[1] === 0x50 && header[2] === 0x4E && header[3] === 0x47) {
            return 'image/png';
        }
        else if (header[0] === 0xFF && header[1] === 0xD8 && header[2] === 0xFF) {
            return 'image/jpeg';
        }
        else if (header[0] === 0x47 && header[1] === 0x49 && header[2] === 0x46) {
            return 'image/gif';
        }
        // unknown format - use generic as application/octet-stream takes too much space in the header
        return 'image/*';
    }
    async getFilesForBundler() {
        return [{
                path: `fs/${this.id}/zpt`,
                bin: await this.getZpt()
            }];
    }
}
